<template>
        

  <layout :showuserinfo="false" >
  	<div class="container-fluid  h-100">
            <div class="page-wrapper-portal">
               <MenuNav />  
                <div class="card" >
                    <Menu :auth="auth" :link="'changePassword'" />
                   
                        <!-- -->
                        <div class="row">
                            <div class="col-lg-9">
                                <div class="row justify-content-center">
                                    
                                    <!-- -->
                                    <div class="">
                                        <div class="card report-card">
                                            <div class="card-body card-scroll">
                                                
                                                

                                                <!-- -->
                                                                                                        <!-- -->
                                                <div class="col-lg-12">
                                                    <div class="card">



                                    <div class="card-header">
                                        <h4 class="card-title"><i class="mdi  mdi-lock-outline font-16 me-2"></i>Tukar Kata Laluan</h4>
                                    </div><!--end card-header-->

                                    <!--end card-header-->
                                    <!-- <w-notification
        v-if="$page.props.flash.errors"
        error
        transition="bounce"
        absolute
        plain
        round
        timeout="2000"
        @close="$page.props.flash.notify = ''"
        >
        {{$page.props.flash.errors}}
      </w-notification> -->
                                     <!-- <w-alert
          class="my0 mb2 text-light"
          v-if="$page.props.flash.errors"
          error
          transition="bounce"
          plain
          round
          timeout="2000"
          no-border
          dismiss
          >
            {{$page.props.flash.errors}}
        </w-alert> -->
                <w-alert
          bg-color="red" color="white"
          class="my0 mb2 text-light"
          v-if="$page.props.flash.errors"
          transition="bounce"
          plain
          round
          
          >
          <w-flex class="wrapper">
                {{$page.props.flash.errors}}
            <div class="spacer"></div>
                <w-icon
                 md
                 color="red"
                 bg-color="white"
                 @click="pangkal()" >
                 mdi mdi-close
                 </w-icon>
          </w-flex>
        </w-alert>

        <w-alert bg-color="red" color="white"

                                                                class="my0 mb2 text-light"
                                                                v-if="salah"
                                                                transition="bounce"
                                                                plain
                                                                round
                                                               
                                                                >
                                                                <w-flex class="wrapper">
                                                                    {{ salah }}
                                                                    <div class="spacer"></div>
                                                                    <w-icon
                                                                    md
                                                                    color="red"
                                                                    bg-color="white"
                                                                     @click="pangkal2()" >
                                                                     mdi mdi-close</w-icon>
                                                                </w-flex>
        </w-alert>

                                     <w-form @validate="changePassword">
                                    <div class="card-body">
                                        <div class="table-responsive shopping-cart">
                                             <!-- <div class="form-group mt-2">
                                                <label for="email" class="form-label  mb-2">Email</label>
                                                <div class="input-group">                                                                                       
                                                   <w-input 
                                                    outline
                                                    placeholder="Sila Masukkan Email Pengguna"
                                                    type="email"  
                                                    name="email"
                                                    v-model="form.email"
                                                    :validators="[validators.required]"
                                                />     
                                                </div>                                    
                                            </div>end form-group -->

                                            <div class="form-group mt-2">
                                                <label for="password" class="form-label  mb-2">Kata Laluan Lama</label>                                            
                                                <div class="input-group">                                    
                                                    <z-input 
                                                    outline
                                                    placeholder="Sila Masukkan Kata Laluan"
                                                    :type="isPassword ? 'password' : 'text'"
                                                    :inner-icon-right="isPassword ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"
                                                    @click:inner-icon-right="isPassword = !isPassword"  
                                                    name="old_password"
                                                    v-model="form.old_password"
                                                    :validators="[validators.required]"
                                                />      
                                                </div>                               
                                            </div><!--end form-group--> 

                                            <div class="form-group mt-2">
                                                <label for="password" class="form-label  mb-2">Kata Laluan Baru</label>                                            
                                                <div class="input-group">                                    
                                                   <z-input 
                                                    outline
                                                    placeholder="Sila Masukkan Kata Laluan"
                                                    :type="isPassword1 ? 'password' : 'text'"
                                                    :inner-icon-right="isPassword1 ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"
                                                    @click:inner-icon-right="isPassword1 = !isPassword1"  
                                                    name="password"
                                                    v-model="form.password"
                                                    :validators="[validators.required, validators.regex, validators.min8]"
                                                />      
                                                </div>                               
                                            </div><!--end form-group--> 
        
                                            <div class="form-group mt-2">
                                                <label for="password_confirmation" class="form-label">Sah Kata Laluan</label>                                            
                                                <div class="input-group mb-2">                               
                                                   <z-input 
                                                    outline
                                                    placeholder="Sila Sahkan Kata Laluan"
                                                    :type="isPassword2 ? 'password' : 'text'"
                                                    :inner-icon-right="isPassword2 ? 'mdi mdi-eye-off' : 'mdi mdi-eye'"
                                                    @click:inner-icon-right="isPassword2 = !isPassword2"  
                                                    name="password_confirmation"
                                                    v-model="form.password_confirmation"
                                                    :validators="[validators.required, validators.regex, validators.min8]"
                                                />
                                                </div>
                                                 <template v-if="form.password != form.password_confirmation">
                                                <div style="color: red;">Kata Laluan tidak sepadan</div></template>   
                                            </div>

                                                                            <inertia-link :href='$route("landing.carian")' style="text-decoration: none;">
                                  <button class="btn btn-lupa-katalaluan mt4 mb2 ml2" type="">
                                     Tutup
                                     </button>
                                   </inertia-link>
                                              <button class="btn btn-lupa-katalaluan mt4 mb2 ml2" type="submit">Simpan</button>


                                            <!-- <code>* <b>Nota</b> : Sila Pastikan Setiap Pembayaran adalah tepat dan betul, sebelom melakukan pembayaran. Terima Kasih</code> -->

                                        </div><!--end re-table-->

                                    </div><!--end card-body-->
                                     </w-form>
                                </div>
                                                </div><!--end col--> 


                                                <!-- -->



                                            </div><!--end card-body--> 

                                        </div><!--end card--> 
                                    </div> <!--end col--> 

                                    <!-- -->

                                </div><!--end row-->

                            </div><!--end col-->

                        </div><!--end row-->
                        <!-- -->

                    </div><!--end card-body--> 
                </div>
                


        </div>
  	
  </layout>
</template>

<script type="text/javascript">
import ZResource from '@/Modules/z-resource'
import Menu from '../Menu.vue'
import MenuNav from '../MenuNav.vue'



	export default {
    extends: ZResource,
	components: {
	  Menu,MenuNav
	},
	setup () {

	},
    props: {
      auth: [Array, Object],
      users: [Array, Object],
            errors: [Array, Object],

  },
	data() {
	    return {
             isPassword: true,
            isPassword1: true,
            isPassword2: true,
	  no_rujukan: '',
	  senarai : [],
	  total_carian : 0.00,
	  total_pilih : 0.00,
	  cari : 0,
      salah : '',


      form: {
	    valid: null,
	    submitted: false,
	    sent: false,
	    errorsCount: 0,
	    old_password: '',
        password: '',
        password_confirmation: '',
        no_id: '',
		email: '',
	  },

    
	}},
	methods: {
	 
      changePassword() {
                        // window.location.reload();
            if (this.form.old_password != '' && this.form.password != '' && this.form.password_confirmation != '')
            {
                
            // this.$zcomm.add('changePassword',this.form)
            // .then(res => {
            //      this.$inertia.visit(this.$route('landing.carian')+'?success=1')
            //     })
            // .finally(() => {

            //  });
                if (this.form.password == this.form.password_confirmation){
                    this.$inertia.post('changePassword',this.form)
                }
                else {
                    this.notify('Terdapat Ralat Dalam Input Anda', 0)
                }

            }
            else {
                this.notify('Terdapat Ralat Dalam Input Anda', 0)
            }
            
        },

         notify(msg, success = true) {
            if(success)
            
            this.success = msg
            else
            this.salah = msg
        },
              pangkal(){
        this.$page.props.flash.errors = null
    },
      pangkal2(){
        this.salah = null
        }


	},
  mounted() {
    
      
  }
}
</script>
<style type="text/css">
	.card-scroll {
    height: 510px;
    max-height: 510px;
    overflow-y: scroll;
    background: ivory;
}
</style>